<section class="py-5">
  <div class="container">
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="display-5 fw-bold">List of Entries for Show</h1>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <div class="input-group">
          <input type="text" 
                 class="form-control" 
                 placeholder="Search by entry number, horse name, or rider name..." 
                 [(ngModel)]="searchTerm"
                 (input)="filterEntries()">
          <span class="input-group-text">
            <i class="mdi mdi-magnify search-icon"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <thead class="table-light">
              <tr>
                <th class="py-3">Entry</th>
                <th class="py-3">Horse Name</th>
                <th class="py-3">Rider</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of filteredEntries" class="entry-row">
                <td>
                  <a href="/entry/{{showId}}/{{entry.entry}}" class="text-decoration-none text-dark">
                    {{entry.entry}}
                  </a>
                </td>
                <td>
                  <a href="/entry/{{showId}}/{{entry.entry}}" class="text-decoration-none text-dark">
                    {{entry.horseName}}
                  </a>
                </td>
                <td>
                  <a href="/entry/{{showId}}/{{entry.entry}}" class="text-decoration-none text-dark">
                    {{entry.riderName}}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
